/**
 * Пагинация по курсору — §21.1 требует cursor/page pagination.
 * Номеров страниц нет намеренно: при курсоре их не существует.
 * Список, загруженный целиком и листаемый на клиенте, передаёт start —
 * номер первой строки страницы: «Показано 51–100 из 230».
 */

import { ChevronLeft, ChevronRight } from "lucide-react";

import { Button } from "./Button";

interface PaginationProps {
  hasMore: boolean;
  hasPrevious: boolean;
  onNext: () => void;
  onPrevious: () => void;
  loading?: boolean;
  /** Показывается, только если счёт дёшев — §21.1 не требует его всегда. */
  total?: number | null;
  shown?: number;
  /** Номер первой показанной строки, с единицы. */
  start?: number;
}

export function Pagination({
  hasMore,
  hasPrevious,
  onNext,
  onPrevious,
  loading = false,
  total,
  shown,
  start,
}: PaginationProps) {
  if (!hasMore && !hasPrevious) return null;

  return (
    <nav
      aria-label="Постраничная навигация"
      className="flex flex-wrap items-center justify-between gap-3 border-t border-line px-3 py-2"
    >
      <span className="text-xs text-faint tabular-nums">
        {typeof total === "number" && typeof shown === "number" && typeof start === "number"
          ? `Показано ${String(start)}–${String(start + shown - 1)} из ${String(total)}`
          : typeof total === "number" && typeof shown === "number"
          ? `Показано ${String(shown)} из ${String(total)}`
          : typeof shown === "number"
            ? `Показано: ${String(shown)}`
            : ""}
      </span>
      <div className="flex gap-2">
        <Button
          variant="secondary"
          size="sm"
          icon={ChevronLeft}
          onClick={onPrevious}
          disabled={!hasPrevious || loading}
        >
          Назад
        </Button>
        <Button
          variant="secondary"
          size="sm"
          iconRight={ChevronRight}
          onClick={onNext}
          disabled={!hasMore || loading}
        >
          Дальше
        </Button>
      </div>
    </nav>
  );
}
